"use strict";
/**
 * Some utilities for parsing Exif data, which is useful to scrape some info from uploaded images.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDMS = exports.getExifDataForOpeningImage = void 0;
function getExifDataForOpeningImage(exif) {
    try {
        const gpsInfo = exif === null || exif === void 0 ? void 0 : exif.get("GPSInfo");
        return {
            timeTakenExif: getExifDateTime(exif),
            gpsLongExif: parseDMS(gpsInfo === null || gpsInfo === void 0 ? void 0 : gpsInfo.get("GPSLatitude"), gpsInfo === null || gpsInfo === void 0 ? void 0 : gpsInfo.get("GPSLatitudeRef")),
            gpsLatExif: parseDMS(gpsInfo === null || gpsInfo === void 0 ? void 0 : gpsInfo.get("GPSLongitude"), gpsInfo === null || gpsInfo === void 0 ? void 0 : gpsInfo.get("GPSLongitudeRef")),
        };
    }
    catch (e) {
        return {};
    }
}
exports.getExifDataForOpeningImage = getExifDataForOpeningImage;
function parseDMS(dms, direction) {
    if (!dms) {
        return undefined;
    }
    try {
        const parts = dms.split(/[^\d\w\.]+/);
        return convertDMSToDD(parts[0], parts[1], parts[2], direction);
    }
    catch (_a) {
        return undefined;
    }
}
exports.parseDMS = parseDMS;
function convertDMSToDD(degrees, minutes, seconds, direction) {
    let dd = Number(degrees) + Number(minutes) / 60 + Number(seconds) / (60 * 60);
    if (direction === "S" || direction === "W") {
        dd = dd * -1;
    } // Don't do anything for N or E
    return dd;
}
// Tries to determine when the photo was taken based off Exif data.
function getExifDateTime(exif) {
    try {
        const datetime = parseExifTime(exif.get("DateTime"));
        if (datetime) {
            return datetime.toISOString();
        }
        const datetimeOriginal = parseExifTime(exif.get("DateTimeOriginal"));
        return datetimeOriginal === null || datetimeOriginal === void 0 ? void 0 : datetimeOriginal.toISOString();
    }
    catch (e) {
        return undefined;
    }
}
function parseExifTime(exifDatetime) {
    if (!exifDatetime) {
        return undefined;
    }
    try {
        const [y, m, d, h, min, s] = exifDatetime.split(/\D/).map(x => parseInt(x));
        // Exif data does not include timezone data, so we use UTC. Consumers can deal with it as they
        // wish. Keep in mind if we're using this to tell a user when they took the photo, then the
        // correct time to show is the time it was where they took the photo - not translated to their
        // current timezone they are viewing from.
        return new Date(y, m - 1, d, h, min, s);
    }
    catch (e) {
        return undefined;
    }
}
//# sourceMappingURL=data:application/json;base64,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